import React from 'react';

import { Button as AntdButton } from 'antd';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';

import { DashboardJusticeFilterForm } from '../../../../types';

import './FormFooter.less';

interface FormFooterProps {
  setFilter: (value: Partial<DashboardJusticeFilterForm>) => void;
}

export function FormFooter({
  setFilter,
}: Readonly<FormFooterProps>): React.ReactElement {
  const FormFooters = useBaseFormContext<DashboardJusticeFilterForm>();

  function resetFilter() {
    FormFooters.setFieldsValue({
      actionsRequises: undefined,
      dateRangeMiseEnFourriere: undefined,
      fourriere: undefined,
      natureMiseEnFourriere: undefined,
      statut: undefined,
    });
  }

  return (
    <div className={'form-footer-container'}>
      <AntdButton onClick={resetFilter}>Réinitialiser</AntdButton>

      <AntdButton
        type="primary"
        onClick={() => setFilter(FormFooters.getFieldsValue())}
      >
        Rechercher
      </AntdButton>
    </div>
  );
}

export default FormFooter;
